module.exports = __webpack_public_path__ + "kr.svg?931b1eaac1274901ddb66e8a2b444bd6";